export const ADSENSE_READY_EVENT = "apnilist:adsense-ready";
export const LIVE_ADS_ENABLED = process.env.NODE_ENV === "production";

declare global {
  interface Window {
    adsbygoogle?: unknown[];
    apnilistAdsenseReady?: boolean;
  }
}

// Mark the DOM node, not React state: the guard survives effect replay and HMR.
// Never queue work before the script loads: that queue can outlive its ad nodes.
export function requestAd(element: HTMLElement, ready: boolean, push: () => void) {
  if (!ready || !element.isConnected || element.clientWidth <= 0 ||
      element.hasAttribute("data-adsbygoogle-status") ||
      element.hasAttribute("data-apnilist-ad-requested")) return false;
  element.setAttribute("data-apnilist-ad-requested", "true");
  push();
  return true;
}
